export const appConstants = {
  FLASH_MESSAGE_TIMEOUT: 4000,
  TOUCH_BREAKPOINT: 999,

  DEFAULT_DYNAMIC_FIELDS: [
    {
      name: 'Météo',
      required: true,
      type: 1,
      position: 1
    },
    {
      name: 'Pression atmosphérique',
      required: false,
      type: 1,
      position: 2
    }
  ]
}
